import api from "../api";
import business_id from "../business"

export default {
  namespaced: true,
  state: {
    alert_message: '',
    type_message: '',
    modal: '',
    message: '',
    notices: {}
  },
  getters: {
   
  },
  actions: {
  
    async set_alert({ commit }, payload = []) {
      commit("SET_ALERT", payload);
    },

    async set_modal({ commit }, payload = '') {
      commit("SET_MODAL", payload);
    },

    async set_message({ commit }, payload = '') {
      commit("SET_MESSAGE", payload);
    },

    async get_notices({ commit }) {
      try {
        api.get(`/v1/notices`)
          .then((res) => {
            commit("SET_NOTICES", res.data);
          })
          .catch((error) => {
            console.log("notices: ",error)
          })
          .finally(() => (
            // this.loading = false
            console.log('login request end')
          ));
      } catch (e) {
        console.log("notices: ",e)
      }
    },
    async update_notices({ commit }, payload = []) {
      try {
          api.put(`/v1/notices/${payload.id}`, payload)
              .then((res) => {
                commit("SET_NOTICES", res.data);
              })
              .catch((error) => {
                console.log("notices: ",error)
              })
              .finally(() => (
                  // this.loading = false
                  console.log('login request end')
              ));
      } catch (e) {
        console.log("notices: ",e)
      }
    },

    
  },
 
  
  mutations: {
   
    SET_ALERT(state, data){
      state.alert_message = data?.alert_message
      state.type_message = data?.type_message
      console.log("alert", data)
      setTimeout(() => {
        state.alert_message = ''
        state.type_message = ''
      }, 5000)
     
    },

    SET_MODAL(state, data){
      state.modal = data
    },

    SET_MESSAGE(state, data){
      state.message = data
    },

    SET_NOTICES(state, data){
      state.notices = data
    }

    
  }
}